export default __webpack_public_path__ + "static/media/contact me.b967e961.gif";